import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/_services/app.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";

@Component({
  selector: "app-check-devis-prix-modal",
  templateUrl: "./check-devis-prix-modal.component.html",
  styleUrls: ["./check-devis-prix-modal.component.scss"],
  standalone: false,
})
export class CheckDevisPrixModalComponent implements OnInit {
  @Output() cancle: EventEmitter<any> = new EventEmitter<any>();
 minPrix: number = 0;

  constructor(private appService: AppService,
    private localStorageService : LocalStorageService,
  ) {
    const config = this.localStorageService.getConfigs();
    this.minPrix = config.frais_deplacement
  }

  ngOnInit() {}
  handleCancle() {
    this.appService.dispatchModal("CHECK_DEVIS_PRIX", false);
    this.cancle.emit();
  }
}
